import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import ListIcons from './components/ListIcons'
import EmployeeConfirmationForm from '../Employee/components/Profile'
import { ConfirmationProvider } from '@/contexts/confirmation'
import PublicTicketRating from './components/PublicTicketRating'

const UtilModule: RouteObject = {
    path: '',
    children: [
        {
            path: 'icons',
            element: <ListIcons />,
        },
        {
            path: 'employee-confirmation',
            element: (
                <ConfirmationProvider>
                    <EmployeeConfirmationForm />
                </ConfirmationProvider>
            ),
        },
        {
            path: 'feedback',
            element: <PublicTicketRating />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default UtilModule
